import Welcome from '../view/Welcome';
import SendResult from '../view/SendResult';
import MovementGuide from '../view/MovementGuide';
import ScoreViewer from '../view/ScoreViewer';
import TeamScoreViewer from '../view/TeamScoreViewer';
import PairRanks from '../view/PairRanks';
import TeamRanks from '../view/TeamRanks';
import ButlerRanks from '../view/ButlerRanks';
import TablesMap from '../view/TablesMap';
import Matches from '../view/Matches';
import Debug from '../view/Debug';
import Curriculum from '../view/Curriculum';
import DirectorsMap from '../view/DirectorsMap';
import DealEntry from '../view/DealEntry';
import SendDeal from '../view/SendDeal';

export default [
    {path: '/', component: Welcome},
    {path: '/sendResult', name: 'sendResult', component: SendResult},
    {path: '/movementGuide', name: 'movementGuide', component: MovementGuide},
    {path: '/curriculum', name: 'curriculum', component: Curriculum},
    {path: '/scoreViewer', name: 'scoreViewer', component: ScoreViewer},
    {path: '/teamScoreViewer', name: 'teamScoreViewer', component: TeamScoreViewer},
    {path: '/pairRanks', name: 'pairRanks', component: PairRanks},
    {path: '/teamRanks', name: 'teamRanks', component: TeamRanks},
    {path: '/butlerRanks', name: 'butlerRanks', component: ButlerRanks},
    {path: '/tablesMap', name: 'TablesMap', component: TablesMap},
    {path: '/matches', name: 'matches', component: Matches},
    {path: '/directorsMap', name: 'directorsMap', component: DirectorsMap},
    {path: '/dealEntry/:boardNumber', name: 'dealEntry', component: DealEntry, props: true},
    {path: '/sendDeal', name: 'sendDeal', component: SendDeal},
    {path: '/debug', name: 'debug', component: Debug}
];
